import React from 'react';
import styled, { css } from 'styled-components';

import { SmallText, UnstyledLI } from '../../../styles/generic';
import Spacings from '../../../styles/Spacings';

import { TagListProps } from './TagList.types';

const TagList = ({ tags, backgroundFilled, className }: TagListProps) => (
  <List className={className}>
    {tags.map((tag, index) => (
      <UnstyledLI key={index}>
        <StyledTag backgroundFilled={backgroundFilled} data-testid="tag">
          {tag.name}
        </StyledTag>
      </UnstyledLI>
    ))}
  </List>
);

export default TagList;

const List = styled.ul`
  display: inline-flex;
  flex-wrap: wrap;
  gap: ${Spacings.XXS};
  list-style: none;
  margin: 0 0 ${Spacings.XS} 0;
  padding: 0;
`;

const StyledTag = styled(SmallText)<{ backgroundFilled?: boolean }>`
  border: 1px solid ${({ theme }) => theme.colors.abnNeutral90};
  border-radius: ${({ theme }) => theme.radiuses.M};
  color: ${({ theme }) => theme.colors.black};
  padding: ${Spacings.XXS} ${Spacings.XS};
  width: fit-content;

  ${({ backgroundFilled }) =>
    backgroundFilled
      ? css`
          background-color: ${({ theme }) => theme.colors.abnNeutralWhite};
        `
      : undefined}
`;
